// src/ShareButton.tsx
import React, { useState } from 'react';
import { Producto } from './types';

interface ShareButtonProps {
    producto: Producto;
    className?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ producto, className = '' }) => {
    const [copied, setCopied] = useState(false);

    const handleShare = async (e: React.MouseEvent) => {
        e.preventDefault(); // Evita navegar si está dentro de un Link
        e.stopPropagation(); // Evita clicks en contenedores padres

        // Generamos la URL absoluta
        const url = `${window.location.origin}/detalle/${producto.id}`;
        const title = `Mira este ${producto.nombre} en Bestune Cars`;
        const text = `¡Hola! Chequea este ${producto.nombre} que vi en Bestune Cars. Precio: $${producto.precio}`;

        // 1. Intento usar la API nativa de compartir (Móviles)
        if (navigator.share) {
            try {
                await navigator.share({ title, text, url });
            } catch (error) {
                console.log('Error compartiendo', error);
            }
        } else {
            // 2. Fallback para PC: Copiar al portapapeles
            try {
                await navigator.clipboard.writeText(url);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Resetear mensaje después de 2s
            } catch (err) {
                console.error('Error al copiar', err);
            }
        }
    };

    return (
        <button 
            onClick={handleShare}
            className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 group relative ${className} ${copied ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-500 hover:bg-yellow-100 hover:text-yellow-600'}`}
            title="Compartir Vehículo"
        >
            {copied ? (
                // Icono Check (Copiado)
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
            ) : (
                // Icono Compartir
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"></path></svg>
            )}
            
            {/* Tooltip flotante al copiar */}
            {copied && (
                <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded shadow-lg whitespace-nowrap">
                    ¡Link Copiado!
                </span>
            )}
        </button>
    );
};

export default ShareButton;